// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2PR9f","notes":"Notes_notes__2M2FD","note":"Notes_note__2FtFz","markdown":"Notes_markdown__2rxhk"};